import React from 'react';

import modulesImage from '../../../../Assets/Linkages/WorldSpaceWeek/WSW-2026-Modules.jpg';

const WorldSpaceWeek2026 = () => (
  <section className="wsw-2026" aria-labelledby="wsw-2026-title">
    <div className="wsw-2026-intro">
      <p className="section-eyebrow">ROCKET REVOLUTION</p>
      <h2 id="wsw-2026-title">World Space Week 2026</h2>
      <div className="world-space-week-title-line" aria-hidden="true" />
      <p>
        Institute of Space Technology (IST), Islamabad, through the Space Education Research Lab
        (SERL) of NCGSA, is organizing World Space Week 2026 on October 8–9, 2026 under the theme
        “Rocket Revolution.”
      </p>
      <p>
        WSW 2026 will bring together school and college students for 14 engaging modules covering
        rocketry, launch vehicles, space missions, engineering design, space heritage, creative arts,
        and AI-based activities. A special Workshop on Design &amp; Development of Sugar-Propelled
        Rocket will also be conducted as part of the celebrations.
      </p>
    </div>

    <figure className="wsw-2026-poster">
      <img src={modulesImage} alt="World Space Week 2026 Rocket Revolution modules" loading="lazy" />
    </figure>
  </section>
);

export default WorldSpaceWeek2026;
